import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchLookup } from '@store/Lookup/lookupSlice2';
import { useAppDispatch, useAppSelector } from '@store/hooks';

// types: string | string[]
const useLookup = types => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const typeArray = useMemo(() => (Array.isArray(types) ? types : [types]).filter(Boolean), [types]);

  const lookupState = useAppSelector(state => state.Lookup2);

  // نطلب فقط الأنواع اللي ما عندنا لها داتا
  useEffect(() => {
    if (!typeArray.length) return;

    const missingTypes = typeArray.filter(t => !lookupState.data[t] || lookupState.data[t].length === 0);

    if (missingTypes.length > 0) {
      dispatch(fetchLookup(missingTypes));
    }
    // نستخدم join عشان dependency ما تكون array
  }, [dispatch, typeArray.join('|'), lookupState.data]);

  const optionsByType : any = useMemo(() => {
    const options = {};

    typeArray.forEach(type => {
      const raw = lookupState.data[type] || [];

      // بناء الـ options حسب شكل الداتا عندك
      // raw = [{ list: [ { lookupCode, meaning, meaning2, ... }, ... ] }, ...]
      const opts =
        raw
          ?.map(item =>
            item.list?.map(list => ({
              value: list.lookupCode,
              label: i18n.language === 'en' ? list.meaning : list.meaning2
            }))
          )
          .flat()
          .filter(Boolean) || [];

      options[type] = opts;
    });

    return options;
  }, [lookupState.data, typeArray.join('|'), i18n.language]);

  // helper اختياري: يرجع options لنوع واحد
  const getOptions = type => optionsByType[type] || [];

  return {
    optionsByType, // { TYPE: options[] }
    getOptions, // دالة مساعدة لو تحب تستخدمها
    loading: lookupState.loading,
    error: lookupState.error
  };
};

export default useLookup;
